import Vue from 'vue';
/* 过滤用户状态 */
Vue.filter('UserStatus', function(value) {
  value == 1 ? value = '成功' : value = '失败'
  return value
})
/* 过滤用户角色 */
Vue.filter('UserRoles', function(value) {
  var roles = []
  value.forEach(item => {
    roles.push(item.display_name)
  });
  return roles.join(",")
})

/* 时间格式化 */
Vue.filter('DateTime', function(value) {
  value = value.slice(5, 10).split("-")
 let newValue = value[0]+ '月' + value[1] + '日'
  return newValue
})

/* 是否置顶0、1 转换*/
Vue.filter('TranFrom', function(value) {
  value == 1 ? value = '是' : value = '否'
  return value
})

/* 过滤交易状态 */
Vue.filter('TransactionStatus', function(value) {
  value == 1 ? value = '开启' : value = '关闭'
  return value
})

/* 驳回原因 */
Vue.filter('ReasonsRejection', function(value, type) {
  switch(value) {
    case 0: value = '待提交'; break;
    case 1: value = '开票中'; break;
    case 2: value = '复核中'; break;
    case 3: value = '复核通过'; break;
    case 4: type == 'aduit' ? value = '发票寄出' : value = '已开票'; break;
    case 5: value = '复核失败'; break;
    default: break;
  }
  return value
})

/* 过滤开票类目 */
Vue.filter('InvoiceCategory', function(value) {
  value = value.join()
  return value
})


